import React, { PropTypes, Component } from 'react';

import Footer from '../footer/Footer';
import Container from '../../components/layouts/Container';

import { media } from 'style-utils';
import styled from 'styled-components';

const Page = styled.div`
  padding-bottom: 120px;

  ${media.tablet`
    padding-bottom: 220px;
  `}
`;

class FbtPageLayout extends Component {
  render() {
    return (
      <section>
        <Container>
          <Page>{this.props.children}</Page>
        </Container>

        <Footer />
      </section>
    );
  }
}

FbtPageLayout.propTypes = {
  children: PropTypes.object,
};

export default FbtPageLayout;



// WEBPACK FOOTER //
// ./src/layouts/fbt/FbtPageLayout.js